import React, { useEffect, useState } from "react";
import { Button } from "../../Button/index";
import { Icon } from "../../../components/Layout/icons/index";
import { helpers, storage } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { useNavigate } from "react-router-dom";
import Actions from "../../../store/actions";
import Avatar from "assets/images/svg/avatar6.svg";
import outsideClick from "../../../hooks/OutsideClick";
import DownArrow from "assets/images/icons/arrow-down.svg";
import { Modal } from "../../index";
import PaymentModal from "components/Layout/Header/paymentModal";
import { Link } from "react-router-dom";
import i18next from "i18next";
import systemActions from "store/actions/system";
import "./style.scss";
import "./balance-with-account.scss";
import useTranslations from "../../../hooks/useTranslation";
import WarningIcon from "../../../assets/images/icons/warning.svg";
import { Grid } from "antd";

const { useBreakpoint } = Grid;
export function BalanceWithAccount() {
	const currentLangCode = useSelector(state => state.system.currentLangCode);
	const profile = useSelector(state => state.auth.user);
	const { langCodes } = useSelector(state => state.system);
	const currentLangTitle = langCodes.find(l => l.code === currentLangCode);

	const { tr } = useTranslations();

	// const organizations = get(profile, "organizations", []);
	const activeOrganization = get(profile, "organization");
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { ref, isVisible, setIsVisible } = outsideClick();
	const [paymentModal, showPaymentModal] = useState(false);
	const [lowBalanceModal, setLowBalanceModal] = useState(false);
	const screen = useBreakpoint();

	const changeLang = langCode => {
		i18next.changeLanguage(langCode.code);
		dispatch(systemActions.ChangeLanguage(langCode.code));
	};
	const logoutHandler = () => {
		storage.remove("token");
		window.location.reload();
	};
	const lockHandler = () => {
		storage.set("lock_phone", get(profile, "phone"));
		storage.remove("token");
		navigate("/unlock");
		dispatch(Actions.auth.SetToken.request(null));
	};

	const balance = Number(
		get(activeOrganization, "balance", 0) ? activeOrganization.balance : 0
	);

	const debt = Number(
		get(activeOrganization, "debt") && activeOrganization.debt
	);

	useEffect(() => {
		if (balance < 0) {
			setLowBalanceModal(true);
		}
	}, [balance]);

	return (
		<>
			<Modal
				size={500}
				isOpen={lowBalanceModal}
				toggle={() => setLowBalanceModal(false)}
				closeIcon={false}
				backdrop="static"
			>
				<div className="low-balance-modal">
					<div className="low-balance-modal__top">
						<div className="low-balance-modal__icon-wrap">
							<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
								<path
									d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
									stroke="#fff"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						<h2 className="low-balance-modal__title">
							{tr("Баланс отрицательный")}
						</h2>
						<p className="low-balance-modal__subtitle">
							{tr("Ваш баланс ниже нуля")}
						</p>
					</div>

					<div className="low-balance-modal__body">
						<div className="low-balance-modal__amount-card">
							<span className="low-balance-modal__amount-label">
								{tr("Текущий баланс")}
							</span>
							<span className="low-balance-modal__amount-value">
								{helpers.convertToReadable(balance)}
								<span className="low-balance-modal__currency">UZS</span>
							</span>
						</div>

						{debt > 0 && (
							<div className="low-balance-modal__debt-row">
								<span>{tr("Долг")}</span>
								<span className="low-balance-modal__debt-value">
									{helpers.convertToReadable(debt - expiredDebt)} UZS
								</span>
							</div>
						)}

						<p className="low-balance-modal__desc">
							{tr(
								"Для бесперебойной работы системы необходимо пополнить счёт. Нажмите «Оплата», чтобы выбрать способ оплаты."
							)}
						</p>
					</div>

					<div className="low-balance-modal__footer">
						<button
							className="d-btn d-btn-secondary"
							onClick={() => setLowBalanceModal(false)}
						>
							{tr("Понимаю")}
						</button>
						<button
							className="d-btn d-btn-primary"
							onClick={() => {
								setLowBalanceModal(false);
								showPaymentModal(true);
							}}
						>
							{tr("Оплата")}
						</button>
					</div>
				</div>
			</Modal>
			<div className="balance-with-account">
				<Modal
					size={500}
					isOpen={paymentModal}
					toggle={() => showPaymentModal(false)}
				>
					<PaymentModal showPaymentModal={showPaymentModal} />
				</Modal>
				<div
					role="button"
					tabIndex={0}
					className={`balance-with-account__trigger company-name ${balance < 1 ? "--red" : ""}`}
					onClick={() => {
						showPaymentModal(true);
					}}
					onKeyDown={e => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							showPaymentModal(true);
						}
					}}
				>
					<div className="balance-with-account__inner">
						<div className="balance-with-account__body">
							<div className="balance-with-account__label">{tr("Баланс")}</div>
							<span className="balance-with-account__amount">
								{helpers.convertToReadable(balance)} UZS
							</span>
						</div>
						<img src={DownArrow} alt="" className="balance-with-account__chevron" />
					</div>
				</div>
			</div>
		</>
	);
}
